import React from "react";
import ReactExport from "react-data-export";
import * as moment from "moment";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;

export default function CustomerStatusXLSX({ states, date, page }) {
  const { data } = states;
  const filter = data?.filter;
  const ytd = data?.ytd;

  // Enrollment
  let headerEnrollStyles = {
    font: { bold: true, color: { rgb: "FFFFFFFF" } },
    fill: { patternType: "solid", fgColor: { rgb: "00367A2A" } },
  };

  let bodyBgEnrollStyles = {
    light: {
      fill: { fgColor: { rgb: "00CAE8C5" } },
    },
    dark: {
      fill: { fgColor: { rgb: "009DE691" } },
    },
  };

  // Transfer
  let headerTransferStyles = {
    font: { bold: true, color: { rgb: "FFFFFFFF" } },
    fill: { patternType: "solid", fgColor: { rgb: "00214991" } },
  };

  let bodyBgTransferStyles = {
    light: {
      fill: { fgColor: { rgb: "00C5D3Ed" } },
    },
    dark: {
      fill: { fgColor: { rgb: "009EB8E8" } },
    },
  };

  // Total
  let headerTotalStyles = {
    font: { bold: true, color: { rgb: "FFFFFFFF" } },
    fill: { patternType: "solid", fgColor: { rgb: "00BAA93D" } },
  };

  let bodyBgTotalStyles = {
    light: {
      fill: { fgColor: { rgb: "00FCEF9D" } },
    },
    dark: {
      fill: { fgColor: { rgb: "00E3D78A" } },
    },
  };

  let borderStyles = {
    border: {
      top: { style: "thin", color: { rgb: "00000000" } },
      bottom: { style: "thin", color: { rgb: "00000000" } },
      left: { style: "thin", color: { rgb: "00000000" } },
      right: { style: "thin", color: { rgb: "00000000" } },
    },
  };
  const multiDataSet = [
    {
      columns: [
        {
          title: date,
          width: { wch: 20 },
        },
        { title: "", width: { wch: 15 } },
        { title: "", width: { wch: 15 } },
        { title: "", width: { wch: 15 } },
        { title: "", width: { wch: 15 } },
        { title: "", width: { wch: 5 } },
        { title: "YTD", width: { wch: 20 } },
        { title: "", width: { wch: 15 } },
        { title: "", width: { wch: 15 } },
        { title: "", width: { wch: 15 } },
        { title: "", width: { wch: 15 } },
      ],
      data: [
        // ----- Enrollment -----
        // Headings
        [
          {
            value: "ENROLLMENTS",
            style: {
              ...headerEnrollStyles,
              ...borderStyles,
            },
          },
          {
            value: "Customer",
            style: {
              ...headerEnrollStyles,
              alignment: { horizontal: "center" },
              ...borderStyles,
            },
          },
          {
            value: "FSC",
            style: {
              ...headerEnrollStyles,
              alignment: { horizontal: "center" },
              ...borderStyles,
            },
          },
          {
            value: "Program Admin",
            style: {
              ...headerEnrollStyles,
              alignment: { horizontal: "center" },
              ...borderStyles,
            },
          },
          {
            value: "TOTAL",
            style: {
              ...headerEnrollStyles,
              alignment: { horizontal: "center" },
              ...borderStyles,
            },
          },
          { value: "" },
          {
            value: "ENROLLMENTS",
            style: {
              ...headerEnrollStyles,
              ...borderStyles,
            },
          },
          {
            value: "Customer",
            style: {
              ...headerEnrollStyles,
              alignment: { horizontal: "center" },
              ...borderStyles,
            },
          },
          {
            value: "FSC",
            style: {
              ...headerEnrollStyles,
              alignment: { horizontal: "center" },
              ...borderStyles,
            },
          },
          {
            value: "Program Admin",
            style: {
              ...headerEnrollStyles,
              alignment: { horizontal: "center" },
              ...borderStyles,
            },
          },
          {
            value: "TOTAL",
            style: {
              ...headerEnrollStyles,
              alignment: { horizontal: "center" },
              ...borderStyles,
            },
          },
        ],
        // Value
        [
          {
            value: "Submitted",
            style: {
              ...bodyBgEnrollStyles.light,
              border: {
                left: { style: "thin", color: { rgb: "00000000" } },
              },
            },
          },
          {
            value: filter?.customer_enroll,
            style: {
              ...bodyBgEnrollStyles.light,
              ...borderStyles,
            },
          },
          {
            value: filter?.fsc_enroll,
            style: {
              ...bodyBgEnrollStyles.light,
              ...borderStyles,
            },
          },
          {
            value: filter?.marketing_admin_enroll,
            style: {
              ...bodyBgEnrollStyles.light,
              ...borderStyles,
            },
          },
          {
            value:
              parseInt(filter?.customer_enroll) +
              parseInt(filter?.fsc_enroll) +
              parseInt(filter?.marketing_admin_enroll),
            style: {
              ...bodyBgEnrollStyles.dark,
              font: { bold: true },
              ...borderStyles,
            },
          },
          {
            value: "",
          },
          {
            value: "Submitted",
            style: {
              ...bodyBgEnrollStyles.light,
              border: {
                left: { style: "thin", color: { rgb: "00000000" } },
              },
            },
          },
          {
            value: ytd?.customer_enroll,
            style: {
              ...bodyBgEnrollStyles.light,
              ...borderStyles,
            },
          },
          {
            value: ytd?.fsc_enroll,
            style: {
              ...bodyBgEnrollStyles.light,
              ...borderStyles,
            },
          },
          {
            value: ytd?.marketing_admin_enroll,
            style: {
              ...bodyBgEnrollStyles.light,
              ...borderStyles,
            },
          },
          {
            value:
              parseInt(ytd?.customer_enroll) +
              parseInt(ytd?.fsc_enroll) +
              parseInt(ytd?.marketing_admin_enroll),
            style: {
              ...bodyBgEnrollStyles.dark,
              font: { bold: true },
              ...borderStyles,
            },
          },
        ],
        [
          {
            value: "Pending Review",
            style: {
              ...bodyBgEnrollStyles.light,
              border: {
                left: { style: "thin", color: { rgb: "00000000" } },
              },
            },
          },
          {
            value: filter?.customer_approval_pending_enroll,
            style: {
              ...bodyBgEnrollStyles.light,
              ...borderStyles,
            },
          },
          {
            value: filter?.fsc_approval_pending_enroll,
            style: {
              ...bodyBgEnrollStyles.light,
              ...borderStyles,
            },
          },
          {
            value: filter?.marketing_admin_approval_pending_enroll,
            style: {
              ...bodyBgEnrollStyles.light,
              ...borderStyles,
            },
          },
          {
            value:
              parseInt(filter?.customer_approval_pending_enroll) +
              parseInt(filter?.fsc_approval_pending_enroll) +
              parseInt(filter?.marketing_admin_approval_pending_enroll),
            style: {
              ...bodyBgEnrollStyles.dark,
              font: { bold: true },
              ...borderStyles,
            },
          },
          {
            value: "",
          },
          {
            value: "Pending Review",
            style: {
              ...bodyBgEnrollStyles.light,
              border: {
                left: { style: "thin", color: { rgb: "00000000" } },
              },
            },
          },
          {
            value: ytd?.customer_approval_pending_enroll,
            style: {
              ...bodyBgEnrollStyles.light,
              ...borderStyles,
            },
          },
          {
            value: ytd?.fsc_approval_pending_enroll,
            style: {
              ...bodyBgEnrollStyles.light,
              ...borderStyles,
            },
          },
          {
            value: ytd?.marketing_admin_approval_pending_enroll,
            style: {
              ...bodyBgEnrollStyles.light,
              ...borderStyles,
            },
          },
          {
            value:
              parseInt(ytd?.customer_approval_pending_enroll) +
              parseInt(ytd?.fsc_approval_pending_enroll) +
              parseInt(ytd?.marketing_admin_approval_pending_enroll),
            style: {
              ...bodyBgEnrollStyles.dark,
              font: { bold: true },
              ...borderStyles,
            },
          },
        ],
        [
          {
            value: "Not Consented",
            style: {
              ...bodyBgEnrollStyles.light,
              border: {
                left: { style: "thin", color: { rgb: "00000000" } },
              },
            },
          },
          {
            value: filter?.customer_not_consented_enroll,
            style: {
              ...bodyBgEnrollStyles.light,
              ...borderStyles,
            },
          },
          {
            value: filter?.fsc_not_consented_enroll,
            style: {
              ...bodyBgEnrollStyles.light,
              ...borderStyles,
            },
          },
          {
            value: filter?.marketing_admin_not_consented_enroll,
            style: {
              ...bodyBgEnrollStyles.light,
              ...borderStyles,
            },
          },
          {
            value:
              parseInt(filter?.customer_not_consented_enroll) +
              parseInt(filter?.fsc_not_consented_enroll) +
              parseInt(filter?.marketing_admin_not_consented_enroll),
            style: {
              ...bodyBgEnrollStyles.dark,
              font: { bold: true },
              ...borderStyles,
            },
          },
          {
            value: "",
          },
          {
            value: "Not Consented",
            style: {
              ...bodyBgEnrollStyles.light,
              border: {
                left: { style: "thin", color: { rgb: "00000000" } },
              },
            },
          },
          {
            value: ytd?.customer_not_consented_enroll,
            style: {
              ...bodyBgEnrollStyles.light,
              ...borderStyles,
            },
          },
          {
            value: ytd?.fsc_not_consented_enroll,
            style: {
              ...bodyBgEnrollStyles.light,
              ...borderStyles,
            },
          },
          {
            value: ytd?.marketing_admin_not_consented_enroll,
            style: {
              ...bodyBgEnrollStyles.light,
              ...borderStyles,
            },
          },
          {
            value:
              parseInt(ytd?.customer_not_consented_enroll) +
              parseInt(ytd?.fsc_not_consented_enroll) +
              parseInt(ytd?.marketing_admin_not_consented_enroll),
            style: {
              ...bodyBgEnrollStyles.dark,
              font: { bold: true },
              ...borderStyles,
            },
          },
        ],
        [
          {
            value: "Activated for Use",
            style: {
              ...bodyBgEnrollStyles.light,
              border: {
                left: { style: "thin", color: { rgb: "00000000" } },
              },
            },
          },
          {
            value: filter?.customer_consented_enroll,
            style: {
              ...bodyBgEnrollStyles.light,
              ...borderStyles,
            },
          },
          {
            value: filter?.fsc_consented_enroll,
            style: {
              ...bodyBgEnrollStyles.light,
              ...borderStyles,
            },
          },
          {
            value: filter?.marketing_admin_consented_enroll,
            style: {
              ...bodyBgEnrollStyles.light,
              ...borderStyles,
            },
          },
          {
            value:
              parseInt(filter?.customer_consented_enroll) +
              parseInt(filter?.fsc_consented_enroll) +
              parseInt(filter?.marketing_admin_consented_enroll),
            style: {
              ...bodyBgEnrollStyles.dark,
              font: { bold: true },
              ...borderStyles,
            },
          },
          {
            value: "",
          },
          {
            value: "Activated for Use",
            style: {
              ...bodyBgEnrollStyles.light,
              border: {
                left: { style: "thin", color: { rgb: "00000000" } },
              },
            },
          },
          {
            value: ytd?.customer_consented_enroll,
            style: {
              ...bodyBgEnrollStyles.light,
              ...borderStyles,
            },
          },
          {
            value: ytd?.fsc_consented_enroll,
            style: {
              ...bodyBgEnrollStyles.light,
              ...borderStyles,
            },
          },
          {
            value: ytd?.marketing_admin_consented_enroll,
            style: {
              ...bodyBgEnrollStyles.light,
              ...borderStyles,
            },
          },
          {
            value:
              parseInt(ytd?.customer_consented_enroll) +
              parseInt(ytd?.fsc_consented_enroll) +
              parseInt(ytd?.marketing_admin_consented_enroll),
            style: {
              ...bodyBgEnrollStyles.dark,
              font: { bold: true },
              ...borderStyles,
            },
          },
        ],
        [
          {
            value: "Accounts Deactivated",
            style: {
              ...bodyBgEnrollStyles.light,
              border: {
                bottom: { style: "thin", color: { rgb: "00000000" } },
                left: { style: "thin", color: { rgb: "00000000" } },
              },
            },
          },
          {
            value: filter?.customer_deactivated_enroll,
            style: {
              ...bodyBgEnrollStyles.light,
              ...borderStyles,
            },
          },
          {
            value: filter?.fsc_deactivated_enroll,
            style: {
              ...bodyBgEnrollStyles.light,
              ...borderStyles,
            },
          },
          {
            value: filter?.marketing_admin_deactivated_enroll,
            style: {
              ...bodyBgEnrollStyles.light,
              ...borderStyles,
            },
          },
          {
            value:
              parseInt(filter?.customer_deactivated_enroll) +
              parseInt(filter?.fsc_deactivated_enroll) +
              parseInt(filter?.marketing_admin_deactivated_enroll),
            style: {
              ...bodyBgEnrollStyles.dark,
              font: { bold: true },
              ...borderStyles,
            },
          },
          {
            value: "",
          },
          {
            value: "Accounts Deactivated",
            style: {
              ...bodyBgEnrollStyles.light,
              border: {
                bottom: { style: "thin", color: { rgb: "00000000" } },
                left: { style: "thin", color: { rgb: "00000000" } },
              },
            },
          },
          {
            value: ytd?.customer_deactivated_enroll,
            style: {
              ...bodyBgEnrollStyles.light,
              ...borderStyles,
            },
          },
          {
            value: ytd?.fsc_deactivated_enroll,
            style: {
              ...bodyBgEnrollStyles.light,
              ...borderStyles,
            },
          },
          {
            value: ytd?.marketing_admin_deactivated_enroll,
            style: {
              ...bodyBgEnrollStyles.light,
              ...borderStyles,
            },
          },
          {
            value:
              parseInt(ytd?.customer_deactivated_enroll) +
              parseInt(ytd?.fsc_deactivated_enroll) +
              parseInt(ytd?.marketing_admin_deactivated_enroll),
            style: {
              ...bodyBgEnrollStyles.dark,
              font: { bold: true },
              ...borderStyles,
            },
          },
        ],
        // Enrollment END
        // Empty Space
        [
          { value: "" },
          { value: "" },
          { value: "" },
          { value: "" },
          { value: "" },
        ],
        //----- Transfer -----
        // Headings
        [
          {
            value: "TRANSFERS",
            style: {
              ...headerTransferStyles,
              ...borderStyles,
            },
          },
          {
            value: "Customer",
            style: {
              ...headerTransferStyles,
              alignment: { horizontal: "center" },
              ...borderStyles,
            },
          },
          {
            value: "FSC",
            style: {
              ...headerTransferStyles,
              alignment: { horizontal: "center" },
              ...borderStyles,
            },
          },
          {
            value: "Program Admin",
            style: {
              ...headerTransferStyles,
              alignment: { horizontal: "center" },
              ...borderStyles,
            },
          },
          {
            value: "TOTAL",
            style: {
              ...headerTransferStyles,
              alignment: { horizontal: "center" },
              ...borderStyles,
            },
          },
          { value: "" },
          {
            value: "TRANSFERS",
            style: {
              ...headerTransferStyles,
              ...borderStyles,
            },
          },
          {
            value: "Customer",
            style: {
              ...headerTransferStyles,
              alignment: { horizontal: "center" },
              ...borderStyles,
            },
          },
          {
            value: "FSC",
            style: {
              ...headerTransferStyles,
              alignment: { horizontal: "center" },
              ...borderStyles,
            },
          },
          {
            value: "Program Admin",
            style: {
              ...headerTransferStyles,
              alignment: { horizontal: "center" },
              ...borderStyles,
            },
          },
          {
            value: "TOTAL",
            style: {
              ...headerTransferStyles,
              alignment: { horizontal: "center" },
              ...borderStyles,
            },
          },
        ],
        // Value
        [
          {
            value: "Submitted",
            style: {
              ...bodyBgTransferStyles.light,
              border: {
                left: { style: "thin", color: { rgb: "00000000" } },
              },
            },
          },
          {
            value: filter?.customer_transfer,
            style: {
              ...bodyBgTransferStyles.light,
              ...borderStyles,
            },
          },
          {
            value: filter?.fsc_transfer,
            style: {
              ...bodyBgTransferStyles.light,
              ...borderStyles,
            },
          },
          {
            value: filter?.marketing_admin_transfer,
            style: {
              ...bodyBgTransferStyles.light,
              ...borderStyles,
            },
          },
          {
            value:
              parseInt(filter?.customer_transfer) +
              parseInt(filter?.fsc_transfer) +
              parseInt(filter?.marketing_admin_transfer),
            style: {
              ...bodyBgTransferStyles.dark,
              font: { bold: true },
              ...borderStyles,
            },
          },
          {
            value: "",
          },
          {
            value: "Submitted",
            style: {
              ...bodyBgTransferStyles.light,
              border: {
                left: { style: "thin", color: { rgb: "00000000" } },
              },
            },
          },
          {
            value: ytd?.customer_transfer,
            style: {
              ...bodyBgTransferStyles.light,
              ...borderStyles,
            },
          },
          {
            value: ytd?.fsc_transfer,
            style: {
              ...bodyBgTransferStyles.light,
              ...borderStyles,
            },
          },
          {
            value: ytd?.marketing_admin_transfer,
            style: {
              ...bodyBgTransferStyles.light,
              ...borderStyles,
            },
          },
          {
            value:
              parseInt(ytd?.customer_transfer) +
              parseInt(ytd?.fsc_transfer) +
              parseInt(ytd?.marketing_admin_transfer),
            style: {
              ...bodyBgTransferStyles.dark,
              font: { bold: true },
              ...borderStyles,
            },
          },
        ],
        [
          {
            value: "Pending Review",
            style: {
              ...bodyBgTransferStyles.light,
              border: {
                left: { style: "thin", color: { rgb: "00000000" } },
              },
            },
          },
          {
            value: filter?.customer_approval_pending_transfer,
            style: {
              ...bodyBgTransferStyles.light,
              ...borderStyles,
            },
          },
          {
            value: filter?.fsc_approval_pending_transfer,
            style: {
              ...bodyBgTransferStyles.light,
              ...borderStyles,
            },
          },
          {
            value: filter?.marketing_admin_approval_pending_transfer,
            style: {
              ...bodyBgTransferStyles.light,
              ...borderStyles,
            },
          },
          {
            value:
              parseInt(filter?.customer_approval_pending_transfer) +
              parseInt(filter?.fsc_approval_pending_transfer) +
              parseInt(filter?.marketing_admin_approval_pending_transfer),
            style: {
              ...bodyBgTransferStyles.dark,
              font: { bold: true },
              ...borderStyles,
            },
          },
          {
            value: "",
          },
          {
            value: "Pending Review",
            style: {
              ...bodyBgTransferStyles.light,
              border: {
                left: { style: "thin", color: { rgb: "00000000" } },
              },
            },
          },
          {
            value: ytd?.customer_approval_pending_transfer,
            style: {
              ...bodyBgTransferStyles.light,
              ...borderStyles,
            },
          },
          {
            value: ytd?.fsc_approval_pending_transfer,
            style: {
              ...bodyBgTransferStyles.light,
              ...borderStyles,
            },
          },
          {
            value: ytd?.marketing_admin_approval_pending_transfer,
            style: {
              ...bodyBgTransferStyles.light,
              ...borderStyles,
            },
          },
          {
            value:
              parseInt(ytd?.customer_approval_pending_transfer) +
              parseInt(ytd?.fsc_approval_pending_transfer) +
              parseInt(ytd?.marketing_admin_approval_pending_transfer),
            style: {
              ...bodyBgTransferStyles.dark,
              font: { bold: true },
              ...borderStyles,
            },
          },
        ],
        [
          {
            value: "Not Consented",
            style: {
              ...bodyBgTransferStyles.light,
              border: {
                left: { style: "thin", color: { rgb: "00000000" } },
              },
            },
          },
          {
            value: filter?.customer_not_consented_transfer,
            style: {
              ...bodyBgTransferStyles.light,
              ...borderStyles,
            },
          },
          {
            value: filter?.fsc_not_consented_transfer,
            style: {
              ...bodyBgTransferStyles.light,
              ...borderStyles,
            },
          },
          {
            value: filter?.marketing_admin_not_consented_transfer,
            style: {
              ...bodyBgTransferStyles.light,
              ...borderStyles,
            },
          },
          {
            value:
              parseInt(filter?.customer_not_consented_transfer) +
              parseInt(filter?.fsc_not_consented_transfer) +
              parseInt(filter?.marketing_admin_not_consented_transfer),
            style: {
              ...bodyBgTransferStyles.dark,
              font: { bold: true },
              ...borderStyles,
            },
          },
          {
            value: "",
          },
          {
            value: "Not Consented",
            style: {
              ...bodyBgTransferStyles.light,
              border: {
                left: { style: "thin", color: { rgb: "00000000" } },
              },
            },
          },
          {
            value: ytd?.customer_not_consented_transfer,
            style: {
              ...bodyBgTransferStyles.light,
              ...borderStyles,
            },
          },
          {
            value: ytd?.fsc_not_consented_transfer,
            style: {
              ...bodyBgTransferStyles.light,
              ...borderStyles,
            },
          },
          {
            value: ytd?.marketing_admin_not_consented_transfer,
            style: {
              ...bodyBgTransferStyles.light,
              ...borderStyles,
            },
          },
          {
            value:
              parseInt(ytd?.customer_not_consented_transfer) +
              parseInt(ytd?.fsc_not_consented_transfer) +
              parseInt(ytd?.marketing_admin_not_consented_transfer),
            style: {
              ...bodyBgTransferStyles.dark,
              font: { bold: true },
              ...borderStyles,
            },
          },
        ],
        [
          {
            value: "Activated for Use",
            style: {
              ...bodyBgTransferStyles.light,
              border: {
                left: { style: "thin", color: { rgb: "00000000" } },
              },
            },
          },
          {
            value: filter?.customer_consented_transfer,
            style: {
              ...bodyBgTransferStyles.light,
              ...borderStyles,
            },
          },
          {
            value: filter?.fsc_consented_transfer,
            style: {
              ...bodyBgTransferStyles.light,
              ...borderStyles,
            },
          },
          {
            value: filter?.marketing_admin_consented_transfer,
            style: {
              ...bodyBgTransferStyles.light,
              ...borderStyles,
            },
          },
          {
            value:
              parseInt(filter?.customer_consented_transfer) +
              parseInt(filter?.fsc_consented_transfer) +
              parseInt(filter?.marketing_admin_consented_transfer),
            style: {
              ...bodyBgTransferStyles.dark,
              font: { bold: true },
              ...borderStyles,
            },
          },
          {
            value: "",
          },
          {
            value: "Activated for Use",
            style: {
              ...bodyBgTransferStyles.light,
              border: {
                left: { style: "thin", color: { rgb: "00000000" } },
              },
            },
          },
          {
            value: ytd?.customer_consented_transfer,
            style: {
              ...bodyBgTransferStyles.light,
              ...borderStyles,
            },
          },
          {
            value: ytd?.fsc_consented_transfer,
            style: {
              ...bodyBgTransferStyles.light,
              ...borderStyles,
            },
          },
          {
            value: ytd?.marketing_admin_consented_transfer,
            style: {
              ...bodyBgTransferStyles.light,
              ...borderStyles,
            },
          },
          {
            value:
              parseInt(ytd?.customer_consented_transfer) +
              parseInt(ytd?.fsc_consented_transfer) +
              parseInt(ytd?.marketing_admin_consented_transfer),
            style: {
              ...bodyBgTransferStyles.dark,
              font: { bold: true },
              ...borderStyles,
            },
          },
        ],
        [
          {
            value: "Accounts Deactivated",
            style: {
              ...bodyBgTransferStyles.light,
              border: {
                bottom: { style: "thin", color: { rgb: "00000000" } },
                left: { style: "thin", color: { rgb: "00000000" } },
              },
            },
          },
          {
            value: filter?.customer_deactivated_transfer,
            style: {
              ...bodyBgTransferStyles.light,
              ...borderStyles,
            },
          },
          {
            value: filter?.fsc_deactivated_transfer,
            style: {
              ...bodyBgTransferStyles.light,
              ...borderStyles,
            },
          },
          {
            value: filter?.marketing_admin_deactivated_transfer,
            style: {
              ...bodyBgTransferStyles.light,
              ...borderStyles,
            },
          },
          {
            value:
              parseInt(filter?.customer_deactivated_transfer) +
              parseInt(filter?.fsc_deactivated_transfer) +
              parseInt(filter?.marketing_admin_deactivated_transfer),
            style: {
              ...bodyBgTransferStyles.dark,
              font: { bold: true },
              ...borderStyles,
            },
          },
          {
            value: "",
          },
          {
            value: "Accounts Deactivated",
            style: {
              ...bodyBgTransferStyles.light,
              border: {
                bottom: { style: "thin", color: { rgb: "00000000" } },
                left: { style: "thin", color: { rgb: "00000000" } },
              },
            },
          },
          {
            value: ytd?.customer_deactivated_transfer,
            style: {
              ...bodyBgTransferStyles.light,
              ...borderStyles,
            },
          },
          {
            value: ytd?.fsc_deactivated_transfer,
            style: {
              ...bodyBgTransferStyles.light,
              ...borderStyles,
            },
          },
          {
            value: ytd?.marketing_admin_deactivated_transfer,
            style: {
              ...bodyBgTransferStyles.light,
              ...borderStyles,
            },
          },
          {
            value:
              parseInt(ytd?.customer_deactivated_transfer) +
              parseInt(ytd?.fsc_deactivated_transfer) +
              parseInt(ytd?.marketing_admin_deactivated_transfer),
            style: {
              ...bodyBgTransferStyles.dark,
              font: { bold: true },
              ...borderStyles,
            },
          },
        ],
        // Transfer END
        // Empty Space
        [
          { value: "" },
          { value: "" },
          { value: "" },
          { value: "" },
          { value: "" },
        ],
        //----- Total -----
        // Headings
        [
          {
            value: "TOTALS",
            style: {
              ...headerTotalStyles,
              ...borderStyles,
            },
          },
          {
            value: "Customer",
            style: {
              ...headerTotalStyles,
              alignment: { horizontal: "center" },
              ...borderStyles,
            },
          },
          {
            value: "FSC",
            style: {
              ...headerTotalStyles,
              alignment: { horizontal: "center" },
              ...borderStyles,
            },
          },
          {
            value: "Program Admin",
            style: {
              ...headerTotalStyles,
              alignment: { horizontal: "center" },
              ...borderStyles,
            },
          },
          {
            value: "TOTAL",
            style: {
              ...headerTotalStyles,
              alignment: { horizontal: "center" },
              ...borderStyles,
            },
          },
          {
            value: "",
          },
          {
            value: "TOTALS",
            style: {
              ...headerTotalStyles,
              ...borderStyles,
            },
          },
          {
            value: "Customer",
            style: {
              ...headerTotalStyles,
              alignment: { horizontal: "center" },
              ...borderStyles,
            },
          },
          {
            value: "FSC",
            style: {
              ...headerTotalStyles,
              alignment: { horizontal: "center" },
              ...borderStyles,
            },
          },
          {
            value: "Program Admin",
            style: {
              ...headerTotalStyles,
              alignment: { horizontal: "center" },
              ...borderStyles,
            },
          },
          {
            value: "TOTAL",
            style: {
              ...headerTotalStyles,
              alignment: { horizontal: "center" },
              ...borderStyles,
            },
          },
        ],
        // Value
        [
          {
            value: "Submitted",
            style: {
              ...bodyBgTotalStyles.light,
              border: {
                left: { style: "thin", color: { rgb: "00000000" } },
              },
            },
          },
          {
            value: filter?.customer,
            style: {
              ...bodyBgTotalStyles.light,
              ...borderStyles,
            },
          },
          {
            value: filter?.fsc,
            style: {
              ...bodyBgTotalStyles.light,
              ...borderStyles,
            },
          },
          {
            value: filter?.marketing_admin,
            style: {
              ...bodyBgTotalStyles.light,
              ...borderStyles,
            },
          },
          {
            value:
              parseInt(filter?.customer) +
              parseInt(filter?.fsc) +
              parseInt(filter?.marketing_admin),
            style: {
              ...bodyBgTotalStyles.dark,
              font: { bold: true },
              ...borderStyles,
            },
          },
          {
            value: "",
          },
          {
            value: "Submitted",
            style: {
              ...bodyBgTotalStyles.light,
              border: {
                left: { style: "thin", color: { rgb: "00000000" } },
              },
            },
          },
          {
            value: ytd?.customer,
            style: {
              ...bodyBgTotalStyles.light,
              ...borderStyles,
            },
          },
          {
            value: ytd?.fsc,
            style: {
              ...bodyBgTotalStyles.light,
              ...borderStyles,
            },
          },
          {
            value: ytd?.marketing_admin,
            style: {
              ...bodyBgTotalStyles.light,
              ...borderStyles,
            },
          },
          {
            value:
              parseInt(ytd?.customer) +
              parseInt(ytd?.fsc) +
              parseInt(ytd?.marketing_admin),
            style: {
              ...bodyBgTotalStyles.dark,
              font: { bold: true },
              ...borderStyles,
            },
          },
        ],
        [
          {
            value: "Pending Review",
            style: {
              ...bodyBgTotalStyles.light,
              border: {
                left: { style: "thin", color: { rgb: "00000000" } },
              },
            },
          },
          {
            value: filter?.customer_approval_pending,
            style: {
              ...bodyBgTotalStyles.light,
              ...borderStyles,
            },
          },
          {
            value: filter?.fsc_approval_pending,
            style: {
              ...bodyBgTotalStyles.light,
              ...borderStyles,
            },
          },
          {
            value: filter?.marketing_admin_approval_pending,
            style: {
              ...bodyBgTotalStyles.light,
              ...borderStyles,
            },
          },
          {
            value:
              parseInt(filter?.customer_approval_pending) +
              parseInt(filter?.fsc_approval_pending) +
              parseInt(filter?.marketing_admin_approval_pending),
            style: {
              ...bodyBgTotalStyles.dark,
              font: { bold: true },
              ...borderStyles,
            },
          },
          {
            value: "",
          },
          {
            value: "Pending Review",
            style: {
              ...bodyBgTotalStyles.light,
              border: {
                left: { style: "thin", color: { rgb: "00000000" } },
              },
            },
          },
          {
            value: ytd?.customer_approval_pending,
            style: {
              ...bodyBgTotalStyles.light,
              ...borderStyles,
            },
          },
          {
            value: ytd?.fsc_approval_pending,
            style: {
              ...bodyBgTotalStyles.light,
              ...borderStyles,
            },
          },
          {
            value: ytd?.marketing_admin_approval_pending,
            style: {
              ...bodyBgTotalStyles.light,
              ...borderStyles,
            },
          },
          {
            value:
              parseInt(ytd?.customer_approval_pending) +
              parseInt(ytd?.fsc_approval_pending) +
              parseInt(ytd?.marketing_admin_approval_pending),
            style: {
              ...bodyBgTotalStyles.dark,
              font: { bold: true },
              ...borderStyles,
            },
          },
        ],
        [
          {
            value: "Not Consented",
            style: {
              ...bodyBgTotalStyles.light,
              border: {
                left: { style: "thin", color: { rgb: "00000000" } },
              },
            },
          },
          {
            value: filter?.customer_not_consented,
            style: {
              ...bodyBgTotalStyles.light,
              ...borderStyles,
            },
          },
          {
            value: filter?.fsc_not_consented,
            style: {
              ...bodyBgTotalStyles.light,
              ...borderStyles,
            },
          },
          {
            value: filter?.marketing_admin_not_consented,
            style: {
              ...bodyBgTotalStyles.light,
              ...borderStyles,
            },
          },
          {
            value:
              parseInt(filter?.customer_not_consented) +
              parseInt(filter?.fsc_not_consented) +
              parseInt(filter?.marketing_admin_not_consented),
            style: {
              ...bodyBgTotalStyles.dark,
              font: { bold: true },
              ...borderStyles,
            },
          },
          {
            value: "",
          },
          {
            value: "Not Consented",
            style: {
              ...bodyBgTotalStyles.light,
              border: {
                left: { style: "thin", color: { rgb: "00000000" } },
              },
            },
          },
          {
            value: ytd?.customer_not_consented,
            style: {
              ...bodyBgTotalStyles.light,
              ...borderStyles,
            },
          },
          {
            value: ytd?.fsc_not_consented,
            style: {
              ...bodyBgTotalStyles.light,
              ...borderStyles,
            },
          },
          {
            value: ytd?.marketing_admin_not_consented,
            style: {
              ...bodyBgTotalStyles.light,
              ...borderStyles,
            },
          },
          {
            value:
              parseInt(ytd?.customer_not_consented) +
              parseInt(ytd?.fsc_not_consented) +
              parseInt(ytd?.marketing_admin_not_consented),
            style: {
              ...bodyBgTotalStyles.dark,
              font: { bold: true },
              ...borderStyles,
            },
          },
        ],
        [
          {
            value: "Activated for Use",
            style: {
              ...bodyBgTotalStyles.light,
              border: {
                left: { style: "thin", color: { rgb: "00000000" } },
              },
            },
          },
          {
            value: filter?.customer_consented,
            style: {
              ...bodyBgTotalStyles.light,
              ...borderStyles,
            },
          },
          {
            value: filter?.fsc_consented,
            style: {
              ...bodyBgTotalStyles.light,
              ...borderStyles,
            },
          },
          {
            value: filter?.marketing_admin_consented,
            style: {
              ...bodyBgTotalStyles.light,
              ...borderStyles,
            },
          },
          {
            value:
              parseInt(filter?.customer_consented) +
              parseInt(filter?.fsc_consented) +
              parseInt(filter?.marketing_admin_consented),
            style: {
              ...bodyBgTotalStyles.dark,
              font: { bold: true },
              ...borderStyles,
            },
          },
          {
            value: "",
          },
          {
            value: "Activated for Use",
            style: {
              ...bodyBgTotalStyles.light,
              border: {
                left: { style: "thin", color: { rgb: "00000000" } },
              },
            },
          },
          {
            value: ytd?.customer_consented,
            style: {
              ...bodyBgTotalStyles.light,
              ...borderStyles,
            },
          },
          {
            value: ytd?.fsc_consented,
            style: {
              ...bodyBgTotalStyles.light,
              ...borderStyles,
            },
          },
          {
            value: ytd?.marketing_admin_consented,
            style: {
              ...bodyBgTotalStyles.light,
              ...borderStyles,
            },
          },
          {
            value:
              parseInt(ytd?.customer_consented) +
              parseInt(ytd?.fsc_consented) +
              parseInt(ytd?.marketing_admin_consented),
            style: {
              ...bodyBgTotalStyles.dark,
              font: { bold: true },
              ...borderStyles,
            },
          },
        ],
        [
          {
            value: "Accounts Deactivated",
            style: {
              ...bodyBgTotalStyles.light,
              border: {
                bottom: { style: "thin", color: { rgb: "00000000" } },
                left: { style: "thin", color: { rgb: "00000000" } },
              },
            },
          },
          {
            value: filter?.customer_deactivated,
            style: {
              ...bodyBgTotalStyles.light,
              ...borderStyles,
            },
          },
          {
            value: filter?.fsc_deactivated,
            style: {
              ...bodyBgTotalStyles.light,
              ...borderStyles,
            },
          },
          {
            value: filter?.marketing_admin_deactivated,
            style: {
              ...bodyBgTotalStyles.light,
              ...borderStyles,
            },
          },
          {
            value:
              parseInt(filter?.customer_deactivated) +
              parseInt(filter?.fsc_deactivated) +
              parseInt(filter?.marketing_admin_deactivated),
            style: {
              ...bodyBgTotalStyles.dark,
              font: { bold: true },
              ...borderStyles,
            },
          },
          {
            value: "",
          },
          {
            value: "Accounts Deactivated",
            style: {
              ...bodyBgTotalStyles.light,
              border: {
                bottom: { style: "thin", color: { rgb: "00000000" } },
                left: { style: "thin", color: { rgb: "00000000" } },
              },
            },
          },
          {
            value: ytd?.customer_deactivated,
            style: {
              ...bodyBgTotalStyles.light,
              ...borderStyles,
            },
          },
          {
            value: ytd?.fsc_deactivated,
            style: {
              ...bodyBgTotalStyles.light,
              ...borderStyles,
            },
          },
          {
            value: ytd?.marketing_admin_deactivated,
            style: {
              ...bodyBgTotalStyles.light,
              ...borderStyles,
            },
          },
          {
            value:
              parseInt(ytd?.customer_deactivated) +
              parseInt(ytd?.fsc_deactivated) +
              parseInt(ytd?.marketing_admin_deactivated),
            style: {
              ...bodyBgTotalStyles.dark,
              font: { bold: true },
              ...borderStyles,
            },
          },
        ],
        // Total END
        // END of []
      ],
    },
  ];

  return (
    <ExcelFile
      filename={
        `${page.replace(/ /g, "")}` +
        " " +
        moment(new Date()).format("MM-DD-YYYY,h:mm A")
      }
      element={
        <button id="csv" style={{ display: "none" }}>
          Hidden btn
        </button>
      }
    >
      <ExcelSheet dataSet={multiDataSet} name="Organization" />
    </ExcelFile>
  );
}
